import { useStaticQuery, graphql } from "gatsby"

export const useAgendaEvent = () => {
  const data = useStaticQuery(
    graphql`
      query {
        allNodeEvenements(sort: { fields: field_date_de_debut, order: ASC }) {
          ...AllEvents
        }
        taxonomyTermZoneDefinie(name: { eq: "evenements" }) {
          ...AllEventsTaxo
        }
      }
    `
  )
  return data
}

export const queryEvent = graphql`
  fragment AllEvents on node__evenementsConnection {
    edges {
      node {
        drupal_internal__nid
        title
        body {
          summary
          processed
        }
        path {
          alias
        }
        fields {
          date_de_debut
          date_de_fin
          formatted_field_date_de_debut
          formatted_field_date_de_fin
          formatted_for_compare_field_date_de_debut
          formatted_for_compare_field_date_de_fin
        }
        field_affichage_planifie
        field_date_de_depublication(formatString: "DD/MM/YYYY", locale: "fr")
        field_date_de_publication(formatString: "DD/MM/YYYY", locale: "fr")
        field_date_de_debut(formatString: "DD/MM/YYYY", locale: "fr")
        field_date_de_fin(formatString: "DD/MM/YYYY", locale: "fr")
        field_evenement_recurrent
        field_date_recurrente {
          value(formatString: "DD/MM/YYYY", locale: "fr")
          end_value(formatString: "DD/MM/YYYY", locale: "fr")
          rrule
          infinite
        }
        drupal_id
        field_url_lieu {
          title
          uri
        }
        relationships {
          field_taxonomie_thematique {
            name
          }
          field_image_event {
            localFile {
              extension
              SlugifiedPublicUrl
            }
          }
        }
      }
    }
  }
`

export const queryTaxo = graphql`
  fragment AllEventsTaxo on taxonomy_term__zone_definie {
    drupal_internal__tid
    field_label
    description {
      processed
    }
  }
`
